import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getpaymentDetails } from "../../../../redux/slices/paymentSlice";

const PaymentDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { paymentDetails } = useSelector((state) => state.paymentSlice);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getpaymentDetails(id, setIsLoading));
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div class="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <div>
          <div className="row mt-3">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="row mt-4">
                    <div className="col">
                      <h5 className="mb-4">Payment Details</h5>
                      <p>Payment Id: {paymentDetails?._id}</p>
                      <p>Order Id: {paymentDetails?.orderId}</p>
                      <p>Name: {paymentDetails?.createdBy?.fullName}</p>
                      <p>Amount: {paymentDetails?.amount}</p>
                      <p>Currency: {paymentDetails?.currency}</p>
                      <p>
                        Payment Status:{" "}
                        <span
                          className={`${
                            paymentDetails?.paymentStatus === "success"
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {paymentDetails?.paymentStatus == "failure"
                            ? "Failed"
                            : "Success"}
                        </span>{" "}
                      </p>
                      <p>Transaction Id: {paymentDetails?.transactionId}</p>
                      <p>Created At: {paymentDetails?.createdAt}</p>
                      {paymentDetails?.other &&
                        Object.entries(paymentDetails.other).map(
                          ([key, value]) => (
                            <p key={key}>
                              {key
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              :
                              {typeof value === "object"
                                ? JSON.stringify(value)
                                : String(value)}
                            </p>
                          )
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentDetail;
